import { Select } from '@mantine/core';

export default Select.extend({
	defaultProps: {
		size: 'xs',
		allowDeselect: false
	}
});
